import { createGlobalStyle } from 'styled-components';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import About from './components/About';
import Products from './components/Products';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import TruckBanner from './components/TruckBanner';
import Login from './pages/Login';
import Fichas from './pages/Fichas';
import FichasLista from './pages/FichasLista';
import FichaPublica from './pages/FichaPublica';
import OrdenesLista from './pages/OrdenesLista';
import OrdenCompra from './pages/OrdenCompra';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --red:      #D0021B;
    --red-dk:   #A50116;
    --red-lt:   #FCE8EB;
    --accent:   #D0021B;
    --blue:     #1F5D8C;
    --blue-lt:  #EBF3FA;
    --blue-dk:  #174972;
    --dark:     #111111;
    --dark2:    #1C1C1C;
    --gray:     #666666;
    --mid:      #F2F2F2;
    --light:    #FAFAFA;
    --white:    #FFFFFF;
    --text:     #1A1A1A;
    --text-sub: #555555;
    --green-wa: #25D366;
    --border:   #E5E5E5;
    --shadow-3d:
      1px 1px 0 #F5C000,
      2px 2px 0 #E0A800,
      3px 3px 0 #C89000,
      4px 4px 0 rgba(180,120,0,0.25);
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'Inter', sans-serif;
    background-color: #f5f0ea;
    background-image:
      linear-gradient(rgba(255,255,255,0.82), rgba(255,255,255,0.82)),
      url('/img/wood-bg.jpg');
    background-repeat: repeat;
    background-size: 612px auto;
    color: var(--text);
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 { font-weight: 700; line-height: 1.15; }
  a { text-decoration: none; color: inherit; }
  ul { list-style: none; }
  img { max-width: 100%; display: block; }

  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: var(--mid); }
  ::-webkit-scrollbar-thumb { background: var(--red); border-radius: 2px; }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
  }
`;

function ProtectedRoute({ children }) {
  const { isAuth } = useAuth();
  return isAuth ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GlobalStyle />
        <Routes>
          {/* Página principal */}
          <Route path="/" element={
            <>
              <Navbar />
              <main>
                <Hero />
                <Benefits />
                <TruckBanner />
                <About />
                <Products />
                <Clients />
                <Contact />
              </main>
              <Footer />
              <WhatsAppFloat />
            </>
          } />

          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Ficha pública — sin autenticación */}
          <Route path="/fichas/ver/:id" element={<FichaPublica />} />

          {/* Fichas técnicas — área privada */}
          <Route path="/fichas" element={
            <ProtectedRoute><FichasLista /></ProtectedRoute>
          } />
          <Route path="/fichas/nueva" element={
            <ProtectedRoute><Fichas /></ProtectedRoute>
          } />
          <Route path="/fichas/editar/:id" element={
            <ProtectedRoute><Fichas /></ProtectedRoute>
          } />

          {/* Órdenes de compra */}
          <Route path="/fichas/ordenes" element={
            <ProtectedRoute><OrdenesLista /></ProtectedRoute>
          } />
          <Route path="/fichas/ordenes/nueva" element={
            <ProtectedRoute><OrdenCompra /></ProtectedRoute>
          } />
          <Route path="/fichas/ordenes/editar/:id" element={
            <ProtectedRoute><OrdenCompra /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
